module.exports = __webpack_public_path__ + "static/For_Your_Assurance-569933fdcb502ce41b7561d4b5063acc.png";